export default {
      id: "arrow-up-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "icons.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }